import React, { useEffect } from 'react';
import { Bar, Line } from 'react-chartjs-2';

const Trends = ({ data }) => {
  // Assuming you have data for all months (Jan to Dec) with null values for missing months
  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];



  // Extract data for each category (imported, exported, recycled)
  const importedData = months.map(month => data[month]?.imported || 0);
  const exportedData = months.map(month => data[month]?.exported || 0);
  const recycledData = months.map(month => data[month]?.recycled || 0);

  const chartData = {
    labels: months,
    datasets: [
      {
        label: 'Imported',
        data: importedData,
        backgroundColor: 'red',
      },
      {
        label: 'Exported',
        data: exportedData,
        backgroundColor: 'blue',
      },
      {
        label: 'Recycled',
        data: recycledData,
        backgroundColor: 'green',
      },
    ],
  };

  const chartOptions = {
    scales: {
      y: {
        beginAtZero: true,
      },
    },
    plugins: {
      legend: {
        display: true,
        position: 'top', // Change the legend position as needed
      },
    },
  };

  return (
    <div>
      {/* <h2>Trends Chart</h2>
      <Line data={chartData} options={chartOptions} /> */}
      <Bar data={chartData} options={chartOptions} />
    </div>
  );
};

export default Trends;
